import React from 'react'
import Nav from '../Nav'
import Dishes from '../Dishes'
import Footer from '../Footer'

function MenuPage() {
  return (
    <>
    <Nav />
    <Dishes />
    <Footer />
    </>
  )
}

export default MenuPage
